/*
 *
 * Settings actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';

export const fetchCurrentPlan = createAction(`${SLICE_NAME}/fetchCurrentPlan`);
